import { DraggableProvidedDragHandleProps } from "@hello-pangea/dnd";
import { DragHandle } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import CloseIcon from "assets/icons/CloseIcon";
import CheckboxControl from "components/form/CheckboxControl";
import TextFieldControl from "components/form/TextFieldControl";
import { QuestionInputs } from "pages/Question/view/types";
import { FieldArrayWithId } from "react-hook-form";

interface CheckboxItemProps {
  element: FieldArrayWithId<QuestionInputs, "partsInput", "formId">;
  index: number;
  removeCheckbox: (index: number) => void;
  dragHandleProps: DraggableProvidedDragHandleProps | null;
  isEditing: boolean;
}

const CheckboxItem = ({ element, index, removeCheckbox, dragHandleProps, isEditing }: CheckboxItemProps) => {
  return (
    <Stack
      direction='row'
      spacing={1}
      alignItems='center'
      key={`multiple-answer-${element.formId}`}>
      <div {...dragHandleProps}>
        <IconButton
          onClick={() => {}}
          disabled={!isEditing}>
          <DragHandle />
        </IconButton>
      </div>
      <CheckboxControl
        name={`partsInput.${index}.isCorrect`}
        sx={{ margin: 0 }}
        disabled={!isEditing}
      />
      <TextFieldControl
        placeholder='Ответ'
        name={`partsInput.${index}.content`}
        rules={{ required: true }}
        multiline
        fullWidth
        disabled={!isEditing}
      />
      <IconButton
        onClick={() => removeCheckbox(index)}
        disabled={!isEditing}>
        <CloseIcon />
      </IconButton>
    </Stack>
  );
};

export default CheckboxItem;
